/**
 * Conversion Wizard Page
 *
 * Main page component for the multi-step C10 conversion wizard.
 * Routes to the appropriate step component based on wizard state.
 *
 * Session 4.1: Wizard State Machine + Steps 1-2
 */

import {
  WizardProvider,
  WizardLayout,
  Step1Source,
  Step2Period,
  Step3Validate,
  Step4Generate,
  useWizard,
} from '@/features/wizard';

/**
 * Internal wizard router component.
 * Renders the appropriate step based on current state.
 */
function WizardRouter() {
  const { state } = useWizard();

  // Render current step
  switch (state.currentStep) {
    case 'source':
      return <Step1Source />;
    case 'period':
      return <Step2Period />;
    case 'validate':
      return <Step3Validate />;
    case 'generate':
      return <Step4Generate />;
    default:
      return <Step1Source />;
  }
}

/**
 * Main conversion wizard page.
 * Wraps the wizard in context provider and layout.
 */
export function ConversionWizard() {
  return (
    <WizardProvider>
      <WizardLayout>
        <WizardRouter />
      </WizardLayout>
    </WizardProvider>
  );
}

export default ConversionWizard;
